<template>
  <div class="home mt-2">
    <!-- Encabezado unificado con filtros colapsables -->
    <entity-header
      title="Productos"
      new-label="Nuevo Producto"
      new-tooltip="Nuevo Producto"
      :has-active-filters="hasActiveFilters"
      @toggle-filters="cargarFiltros"
      @export="getProductosExcel"
      @new="showEdit({}, 'add')"
      @search="onBuscar"
    >
      <template #filters>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="producto_filter">Por Producto</label>
          <input
            type="text"
            class="form-control"
            id="producto_filter"
            name="producto_sel"
            placeholder="Filtrar por producto..."
            @keyup.enter="onBuscar"
            v-model="producto_sel"
            aria-label="Producto"
          />
        </div>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="alias_filter">Por Alias</label>
          <input
            type="text"
            class="form-control"
            id="alias_filter"
            name="alias_sel"
            placeholder="Filtrar por alias..."
            @keyup.enter="onBuscar"
            v-model="alias_sel"
            aria-label="Alias"
          />
        </div>
        <div class="form-group col-md-3 mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="categoria_filter">Por Categoría</label>
          <select
            class="form-control"
            v-model="id_categoria_sel"
            id="categoria_filter"
            aria-label="Categoría"
            @change="onBuscar"
          >
            <option selected :value="null">Todas las categorías</option>
            <option
              v-for="cat in categoriasList"
              :key="cat.id_categoria || cat.id"
              :value="cat.id_categoria || cat.id"
            >
              {{ cat.categoria }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-3 mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="enabled_select">Por Estado</label>
          <select
            class="form-control"
            v-model="activo_sel"
            name="atributo"
            aria-label="Activo"
            id="enabled_select"
          >
            <option selected :value="null">Todos los estados</option>
            <option :value="0">Inactivo</option>
            <option :value="1">Activo</option>
          </select>
        </div>
      </template>
    </entity-header>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <!-- Tabla de datos estandarizada con acciones -->
    <data-table
      v-if="productosBusqueda && productosBusqueda.data && productosBusqueda.data.length"
      :columns="columns"
      :data="productosBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_producto"
      @sort="orderByfield"
    >
      <template #cell-integrador="{ item, value }">
        {{ value || getIntegradorName(item.id_integrador) }}
      </template>

      <template #cell-categoria="{ item, value }">
        {{ value || getCategoriaName(item.id_categoria) || '-' }}
      </template>

      <template #actions="{ item }">
        <table-actions
          :item="item"
          active-key="activo"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        >
          <template #extra>
            <button
              type="button"
              class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Atributos del producto"
              @click="openAtributosModal(item)"
            >
              <small class="bi-bar-chart-steps"></small>
            </button>
          </template>
        </table-actions>
      </template>
    </data-table>

    <!-- Paginador y estado vacío -->
    <Paginador
      v-if="productosBusqueda && productosBusqueda.pages"
      :pages="productosBusqueda.pages"
      @selPage="changePage"
    ></Paginador>

    <empty-state
      :show="Boolean(post && productosBusqueda && productosBusqueda.data && !productosBusqueda.data.length)"
      message="No se encontraron productos que coincidan con la búsqueda."
    />

    <!-- Modal Flotante de Atributos -->
    <crud-modal
      :show="showAtributosModal"
      size="xl"
      :title="atributosModalTitle"
      :show-save="false"
      cancel-text="Cerrar"
      @close="closeAtributosModal"
    >
      <Atributos
        v-if="selectedProductoAtributos"
        :propProducto="selectedProductoAtributos.id_producto"
        :propIntegrador="selectedProductoAtributos.id_integrador"
        :isModal="true"
      />
    </crud-modal>

    <!-- Modal CRUD Estandarizado -->
    <crud-modal
      :show="showModal"
      :title="modalTitle"
      size="lg"
      :is-toggle="operation == 'toggle'"
      :show-save="operation == 'edit' || operation == 'add' || operation == 'toggle' || operation == 'delete'"
      :save-text="modalSaveText"
      :save-variant="operation == 'delete' ? 'danger' : (operation == 'toggle' ? (editData && (editData.activo == 1 || editData.activo == '1') ? 'warning' : 'success') : 'primary')"
      @close="closeModal"
      @save="onModalSave"
    >
      <template #toggle-info>
        <div
          v-if="operation === 'toggle' && editData && (editData.activo == 1 || editData.activo == '1')"
          class="alert alert-info d-flex align-items-center mb-3"
          role="alert"
        >
          <i class="bi bi-info-circle-fill mr-2" style="font-size: 1.25rem;"></i>
          <div>
            <strong>Información:</strong> Esto implica que no se podrán dar nuevas altas sobre los servicios asociados, esto no afecta a las solicitudes de bajas.
          </div>
        </div>
      </template>

      <template #toggle-message>
        <div v-if="operation === 'toggle' && editData && (editData.activo == 1 || editData.activo == '1')">
          <strong>Advertencia:</strong> Al desactivar este producto se desactivarán automáticamente sus servicios asociados.
        </div>
      </template>

      <form v-if="editData && (operation == 'delete' || operation == 'edit' || operation == 'add')">
        <div v-if="operation == 'add' && isTodosIntegrador" class="form-group">
          <label>Integrador</label>
          <select
            class="form-control"
            name="id_integrador"
            :class="{ 'is-invalid': hasFieldError('id_integrador') }"
            v-model="editData.id_integrador"
            @change="onModalIntegradorChange"
            required
          >
            <option :value="null">Seleccione un integrador...</option>
            <option
              v-for="item in integradoresList"
              :key="item.id_integrador || item.id"
              :value="item.id_integrador || item.id"
            >
              {{ item.integrador }}
            </option>
          </select>
          <small class="form-text text-muted">Seleccione el integrador para este producto.</small>
        </div>
        <div v-else-if="operation == 'edit' || operation == 'delete'" class="form-group">
          <label>Integrador</label>
          <input
            type="text"
            class="form-control"
            :value="editData.integrador || getIntegradorName(editData.id_integrador)"
            disabled
            readonly
          />
          <small class="form-text text-muted">Integrador al que pertenece el producto (no editable).</small>
        </div>
        <div v-else-if="operation == 'add'" class="form-group">
          <label>Integrador</label>
          <input
            type="text"
            class="form-control"
            :value="getIntegradorName(id_integrador_sel)"
            disabled
            readonly
          />
          <small class="form-text text-muted">Integrador seleccionado para el nuevo producto.</small>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Producto</label>
              <b class="form-control" v-if="operation == 'delete'">
                {{ editData.producto }}
              </b>
              <input
                class="form-control"
                name="producto"
                :class="{ 'is-invalid': hasFieldError('producto') }"
                v-if="operation == 'edit' || operation == 'add'"
                type="text"
                placeholder="Ej: Club Juegos"
                v-model="editData.producto"
              />
              <small class="form-text text-muted">Nombre interno del producto.</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre (Alias)</label>
              <b class="form-control" v-if="operation == 'delete'">
                {{ editData.alias }}
              </b>
              <input
                class="form-control"
                name="alias"
                :class="{ 'is-invalid': hasFieldError('alias') }"
                v-if="operation == 'edit' || operation == 'add'"
                type="text"
                placeholder="Ej: clubjuegos"
                v-model="editData.alias"
              />
              <small class="form-text text-muted">Nombre del producto que se muestra al usuario.</small>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Categoría <span class="text-danger">*</span></label>
          <b class="form-control" v-if="operation == 'delete'">
            {{ getCategoriaName(editData.id_categoria) || 'Sin categoría' }}
          </b>
          <select
            class="form-control"
            name="id_categoria"
            :class="{ 'is-invalid': hasFieldError('id_categoria') }"
            v-if="operation == 'edit' || operation == 'add'"
            v-model="editData.id_categoria"
            required
          >
            <option :value="null">Seleccione una categoría...</option>
            <option
              v-for="cat in categoriasList"
              :key="cat.id_categoria || cat.id"
              :value="cat.id_categoria || cat.id"
            >
              {{ cat.categoria }}
            </option>
          </select>
          <small class="form-text text-muted">Categoría a la que pertenece el producto.</small>
        </div>

        <div v-if="errors" class="alert alert-danger my-2" role="alert">
          <i class="bi bi-exclamation-triangle me-1"></i>
          {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
        </div>
      </form>
    </crud-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { entityCrudMixin } from "@/mixins/entityCrudMixin";
import { startAsyncExport } from "@/utils/exportHelper";
import { fetchCachedCatalog } from "../../utils/filterCache";
import EntityHeader from "./utiles/EntityHeader.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import Paginador from "./Paginador.vue";
import CrudModal from "./utiles/CrudModal.vue";
import Atributos from "./Atributos.vue";

export default {
  name: "Productos",
  mixins: [entityCrudMixin],

  components: {
    EntityHeader,
    DataTable,
    TableActions,
    EmptyState,
    Paginador,
    CrudModal,
    Atributos,
  },

  data() {
    return {
      columns: [
        { label: "Id", field: "id_producto", width: "80" },
        { label: "Integrador", field: "integrador" },
        { label: "Producto", field: "producto" },
        { label: "Alias", field: "alias" },
        { label: "Categoría", field: "categoria" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      showAtributosModal: false,
      selectedProductoAtributos: null,
      busqueda_global: "",
      billRestriction: null,
      scPayments: null,
      scFrequency: null,
      scLifetime: null,
      scPrice: null,
      scPriceImp: null,
      activo_sel: null,
      id_categoria_sel: null,
      categorias: [],
      success: null,
      id_producto: null,
      atributos: [],
      atributosDefault: [],
      atributosProd: [],
      atributosFinal: [],
      disabled_pin_message: false,
      disabled_already_message: false,
      billing_sequence_select: "",
      billing_sc_payments: "",
      billingSequence: null,
      error: null,
      tipos: ["SEQ", "RND"],
      billingsequences: null,
      alias_sel: null,
      id_integrador_sel: localStorage.getItem("integrador") || null,
      producto_sel: null,
      productosBusqueda: null,
      cuadro: [],
      pages: null,
      dias: ["nada", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"],
      attribu: {
        billing_sequence_id: "",
        apigw_v2t_service: "",
        apigw_use_rbt: "",
        apigw_iscustomer_keyword: "",
        apigw_invoce_charge_code: "",
        try_and_buy: "",
        crossselling_unsubscribe_message: "",
        url_club: "",
        pin_message: "",
        optin_message: "",
        already_message: "",
      },
      counter: 0,
      ocultotabla: false,
    };
  },

  created() {
    this.ocultotabla = false;
    this.orderByField = "id_producto";
    this.getCategorias();
    this.getProductosBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),

    modalTitle() {
      if (!this.editData) return "";
      if (this.operation === "toggle") {
        return (this.editData.activo == 1 || this.editData.activo == "1")
          ? "Suspender Producto"
          : "Reactivar Producto";
      }
      if (this.operation === "edit") {
        return `Editar Producto ${this.editData.id_producto || ""}`;
      }
      if (this.operation === "add") {
        return "Nuevo Producto";
      }
      if (this.operation === "delete") {
        return `Borrar Producto ${this.editData.id_producto || ""}`;
      }
      return "";
    },

    modalSaveText() {
      if (this.operation === "delete") return "Borrar";
      if (this.operation === "toggle") {
        return (this.editData && (this.editData.activo == 1 || this.editData.activo == "1"))
          ? "Suspender"
          : "Reactivar";
      }
      return "Guardar";
    },

    atributosModalTitle() {
      if (!this.selectedProductoAtributos) return "Atributos del Producto";
      const p = this.selectedProductoAtributos;
      const name = p.producto || p.nombre || p.descripcion || `ID: ${p.id_producto}`;
      return `Atributos del Producto: ${name}`;
    },

    hasActiveFilters() {
      return (
        Boolean(this.producto_sel) ||
        Boolean(this.alias_sel) ||
        Boolean(this.id_categoria_sel) ||
        (this.activo_sel !== null && this.activo_sel !== undefined)
      );
    },

    categoriasList() {
      let list = [];
      if (this.categorias && Array.isArray(this.categorias)) {
        list = [...this.categorias];
      }
      return list.sort((a, b) =>
        String(a.categoria || "").localeCompare(String(b.categoria || ""), undefined, { sensitivity: "base" })
      );
    },

    isTodosIntegrador() {
      return !this.id_integrador_sel || this.id_integrador_sel === "todos";
    },

    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
  },

  watch: {
    "$store.state.integrador.integrador"(newVal) {
      this.id_integrador_sel = newVal;
      this.page = 1;
      this.getProductosBusqueda();
    },
  },

  methods: {
    getIntegradorName(id) {
      if (!id) return "";
      const list = this.integradores && this.integradores.data ? this.integradores.data : (Array.isArray(this.integradores) ? this.integradores : []);
      const found = list.find((i) => String(i.id_integrador || i.id) === String(id));
      return found ? found.integrador : id;
    },
    buscar(hideResult = false) {
      this.getProductosBusqueda(hideResult);
    },

    onBuscar() {
      this.page = 1;
      this.getProductosBusqueda(true);
    },

    onModalSave() {
      if (this.operation === "delete") return this.deleteProducto();
      if (this.operation === "toggle") return this.toggleStatus();
      if (this.operation === "edit") return this.editProducto();
      if (this.operation === "add") return this.agregarProducto();
    },

    cargarFiltros() {
      this.getCategorias();
      return this.getBillinSequences();
    },

    getCategorias() {
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "categoria/list")
        .then((response) => {
          this.categorias =
            response && response.data && response.data.data
              ? response.data.data
              : response && response.data
              ? response.data
              : [];
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        });
    },

    getCategoriaName(id) {
      if (!id) return "";
      const found = this.categoriasList.find(
        (c) => String(c.id_categoria || c.id) === String(id)
      );
      return found ? found.categoria : id;
    },

    onModalIntegradorChange() {
      if (this.editData.id_integrador) {
        this.getBillinSequences(this.editData.id_integrador);
      } else {
        this.getBillinSequences();
      }
    },

    getBillinSequences(integradorId = null) {
      const targetInteg = integradorId || this.id_integrador_sel;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "billingsequence/list", {
        id_integrador: targetInteg,
      })
        .then((response) => {
          this.billingsequences =
            response && response.data && response.data.data
              ? response.data.data
              : response && response.data
              ? response.data
              : [];
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        });
    },

    getAtributosDefault() {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/defecto")
        .then((response) => {
          this.atributosDefault = response.data.data;
          this.atributosFinal = response.data.data;
          this.atributosDefault.apigw_use_rbt = 0;
          this.disabled_pin_message = this.atributosFinal.pin_message;
          this.disabled_already_message = this.atributosFinal.already_message;
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    getAtributosProducto(id_producto) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/atributos", {
          id_producto: id_producto,
        })
        .then((response) => {
          this.atributos = response.data;
          this.getCuadroBilling(this.atributos.billing_sequence_id);
          this.atributos.billing_sequence_id = this.billing_sequence_id;
          this.billing_sc_payments = this.atributos.billing_sequence_id;
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    getBillingSequence(id_producto) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/getBillingSequence", {
          id_producto: id_producto,
        })
        .then((response) => {
          if (response.data.billing_sequence_id) {
            this.billing_sequence_select = response.data.billing_sequence_id;
            this.billing_sc_payments = response.data.billing_sequence_id;
            this.getCuadroBilling(this.billing_sequence_select);
          } else {
            this.billing_sc_payments = "";
            this.billing_sequence_select = "";
          }
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    getCuadroBilling(billingCodes) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/getCuadro", {
          billingCodes: billingCodes,
        })
        .then((response) => {
          if (response.data.precioFinal) {
            this.cuadro = response.data;
            this.scPayments = response.data.sequence;
            this.scFrequency = response.data.scFrequency;
            this.scLifetime = response.data.scLifetime;
            this.scPrice = response.data.scPrice;
            this.scPriceImp = response.data.scPriceImp;
            this.billRestriction = response.data.billRestriction;
            this.billing_sequence_id =
              response.data.id_billing_sequence || response.data.id_Secuencia;
          } else {
            this.cuadro = "";
          }
        })
        .catch((e) => {
          if (!this.errors) this.errors = [];
          if (Array.isArray(this.errors)) this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    async getProductosBusqueda(hideResult = true) {
      if (hideResult) this.productosBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}producto/busqueda`,
          {
            page: this.page,
            busqueda: this.busqueda_global,
            id_integrador: this.id_integrador_sel,
            id_categoria: this.id_categoria_sel,
            producto: this.producto_sel,
            alias: this.alias_sel,
            activo: this.activo_sel,
            order_by: {
              field: this.orderByField,
              order: this.orderByDirection,
            },
          }
        );
        this.productosBusqueda = response.data;
      } catch (e) {
        if (!this.errors) this.errors = [];
        if (Array.isArray(this.errors)) this.errors.push(e);

        const mensaje =
          e.response?.status === 429
            ? "Espere un momento y vuelva a intentarlo."
            : "Ha ocurrido un error al buscar los Productos";

        Swal.fire({
          title: "Error!",
          text: mensaje,
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } finally {
        this.$store.commit("setLoading", false);
        this.post = true;
      }
    },

    toggleStatus() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      const targetId = this.editData.id_producto;
      const newActivo = 1 - Number(this.editData.activo || 0);
      const payload = {
        ...this.editData,
        activo: newActivo,
      };
      axios
        .post(process.env.VUE_APP_API_URL + "producto/update", payload)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            if (this.productosBusqueda && this.productosBusqueda.data) {
              const idx = this.productosBusqueda.data.findIndex(
                (p) => p.id_producto == targetId
              );
              if (idx !== -1) {
                this.$set(this.productosBusqueda.data[idx], "activo", newActivo);
              }
            }
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Producto actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
            Swal.fire({
              title: "Error!",
              text: e.response.data.error,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {
            this.getProductosBusqueda();
          }
        });
    },

    getProductosExcel() {
      startAsyncExport(
        "producto",
        {
          id_integrador: this.id_integrador_sel,
          id_categoria: this.id_categoria_sel,
          order_by: {
            field: this.orderByField,
            order: this.orderByDirection,
          },
        },
        "Productos"
      );
    },

    editProducto() {
      this.errors = null;
      if (!this.editData.id_categoria) {
        this.errors = "Debe seleccionar una categoría para el producto";
        return;
      }
      delete this.editData.atributos;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Producto actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {
            this.getProductosBusqueda(false);
          }
        });
    },

    deleteProducto() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/delete", {
          id_producto: this.editData.id_producto,
          activo: this.editData.activo == 1 ? 0 : 1,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Producto borrado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar borrar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {
            this.getProductosBusqueda(false);
          }
        });
    },

    openAtributosModal(item) {
      this.selectedProductoAtributos = item;
      this.showAtributosModal = true;
    },

    closeAtributosModal() {
      this.showAtributosModal = false;
      this.selectedProductoAtributos = null;
    },

    showEdit(item, operation) {
      this.cargarFiltros();
      this.getCategorias();
      this.errors = null;
      this.editData = Object.assign({}, item);
      if (this.editData.id_categoria !== undefined && this.editData.id_categoria !== null) {
        this.editData.id_categoria = Number(this.editData.id_categoria) || null;
      }
      this.counter = 0;
      if (operation == "add") {
        this.billing_sc_payments = "";
        this.cuadro = [];
        this.editData.tipo = "";
        this.editData.id_integrador = this.isTodosIntegrador
          ? null
          : parseInt(this.id_integrador_sel);
        this.editData.id_categoria = null;
      } else if (operation == "edit") {
        this.getBillingSequence(item.id_producto);
        if (item.id_integrador) {
          this.getBillinSequences(item.id_integrador);
        }
      }

      this.showModal = true;
      this.operation = operation;
    },

    agregarProducto() {
      this.errors = null;
      if (!this.editData.id_integrador || this.editData.id_integrador === "todos") {
        if (!this.isTodosIntegrador) {
          this.editData.id_integrador = parseInt(this.id_integrador_sel);
        } else {
          this.errors = "Debe seleccionar un integrador para el nuevo producto";
          return;
        }
      }
      if (!this.editData.id_categoria) {
        this.errors = "Debe seleccionar una categoría para el producto";
        return;
      }
      this.$store.commit("setLoading", true);
      delete this.editData.atributos;

      axios
        .post(process.env.VUE_APP_API_URL + "producto/add", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            const createdProd =
              response.data && response.data.data
                ? Object.assign({}, response.data.data)
                : {
                    id_producto:
                      response.data && (response.data.id_producto || response.data.id),
                    producto: this.editData.producto,
                    alias: this.editData.alias,
                    activo: this.editData.activo !== undefined ? this.editData.activo : 1,
                  };
            if (!createdProd.id_producto && response.data && response.data.id_producto) {
              createdProd.id_producto = response.data.id_producto;
            }
            if (!createdProd.producto) {
              createdProd.producto = this.editData.producto;
            }
            if (!createdProd.id_categoria && this.editData.id_categoria) {
              createdProd.id_categoria = this.editData.id_categoria;
            }

            this.closeModal();
            this.openAtributosModal(createdProd);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {
            this.getProductosBusqueda(false);
          }
        });
    },

    isMovistar() {
      return this.user && this.user.rol == "movistar";
    },

    getError(name) {
      if (name) {
        return this.errors && this.errors.errors && this.errors.errors[name]
          ? this.errors.errors[name]
          : null;
      }
      return this.errors && this.errors.error ? this.errors.error : null;
    },
  },
};
</script>

<style scoped></style>